import { render, staticRenderFns } from "./technologyInquiry.vue?vue&type=template&id=134ec834&scoped=true&"
import script from "./technologyInquiry.vue?vue&type=script&lang=js&"
export * from "./technologyInquiry.vue?vue&type=script&lang=js&"
import style0 from "./technologyInquiry.vue?vue&type=style&index=0&id=134ec834&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "134ec834",
  null
  
)

export default component.exports